/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { z, ZodTypes } from './zod';

export { z, ZodTypes };
export type ZodError = z.ZodError;
export { Endpoints } from './definitions';

type Methods = 'get' | 'post' | 'put' | 'patch' | 'delete';

type Body = {
  description?: string;
  required?: boolean;
  content: Partial<Record<'application/json' | 'image/png', { schema: z.ZodTypeAny }>>;
};

export type Endpoint = {
  id: `${string}.${Methods}`;
  tag:
    | 'Admin'
    | 'Advice'
    | 'Authentication'
    | 'Cluster'
    | 'Common'
    | 'Customer'
    | 'Deepthinker'
    | 'Help'
    | 'Inventory'
    | 'Organization'
    | 'Premise'
    | 'Product'
    | 'Project'
    | 'Support'
    | 'Team'
    | 'Thumbnail'
    | 'User'
    | 'Webhook'
    | 'Setup';
  summary: string;
  description: string;
  method: Methods;
  route: (params: any) => string;
  request?: {
    params?: z.AnyZodObject;
    query?: z.AnyZodObject;
    body?: Body;
  };
  response: {
    [status: string]: Body;
  };
  flags?: Partial<{
    isAuthorized: boolean;
    isSuperuser: boolean;
  }>;
};

type Content<T> = T extends { 'application/json': { schema: z.ZodTypeAny } }
  ? z.infer<T['application/json']['schema']>
  : T extends { 'image/png': { schema: z.ZodTypeAny } }
    ? z.infer<T['image/png']['schema']>
    : never;
export type Infer<T extends Endpoint> = {
  Params: T['request'] extends { params: z.AnyZodObject } ? z.infer<T['request']['params']> : never;
  QueryParams: T['request'] extends { query: z.AnyZodObject } ? z.infer<T['request']['query']> : never;
  Body: T['request'] extends { body: Body } ? Content<T['request']['body']['content']> : never;
  Response: {
    [status in keyof T['response']]: Content<T['response'][status]['content']>;
  };
};
